import { colors } from "@mui/material";
import kebabMenuCircle from "../../assets/svg/action/kebab-menu-circle.svg";
import icPen from "../../assets/svg/action/ic-edit-pen-white.svg";

import create_event from "../../assets/faq/event_creation/Create_Event.gif";
import invite_guest from "../../assets/faq/invite_guest/invite_guest.gif";
import share_access from "../../assets/faq/share_access/share_photos.gif";
export const suggestionsTagObj = {
  main: [
    {
      lable: "Event Creation",
      key: "event_creation",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Event Creation</p>,
      hasSuggestion: true,
    },
    {
      lable: "Invitation and Registration",
      key: "invitation_registration",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Invitation and Registration</p>,
      hasSuggestion: true,
    },
    // {
    //   lable: "Upload",
    //   key: "upload",
    //   botMsg: <p>Which of the following do you need help with?</p>,
    //   personMsg: <p>Upload</p>,
    //   hasSuggestion: true,
    // },
    {
      lable: "Folder Creation and Upload Photos",
      key: "folder_creation_upload",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Folder Creation and Upload Photos</p>,
      hasSuggestion: true,
    },
    {
      lable: "Share Photos",
      key: "share_photos",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Share Photos</p>,
      hasSuggestion: true,
    },

    {
      lable: "Upload and Download photos",
      key: "upload_download",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Upload and Download photos</p>,
      hasSuggestion: true,
    },
    {
      lable: "Event Updates & Cancellations",
      key: "event_changes",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Event Updates & Cancellations</p>,
      hasSuggestion: true,
    },
    {
      lable: "Faces & My Photos – Troubleshooting Guide",
      key: "face_myphotos",
      botMsg: <p>Which of the following do you need help with?</p>,
      personMsg: <p>Faces & My Photos – Troubleshooting Guide</p>,
      hasSuggestion: true,
    },
    // {
    //   lable: "Public and Private Folder",
    //   key: "public_private_folder",
    //   botMsg: <p>Which of the following do you need help with?</p>,
    //   personMsg: <p>Public and Private Folder</p>,
    //   hasSuggestion: true,
    // },
  ],
  event_creation: [
    {
      lable: "How to create an event?",
      key: "event_creation1",
      botMsg: (
        <>
          <ul>
            <li>
              Go to{" "}
              <a
                style={{ color: "#0277ad" }}
                href="https://www.jioaicloud.com/"
                target="_blank"
              >
                www.jioaicloud.com
              </a>{" "}
              and open the <strong>PhotoShare</strong> tab.
            </li>
            <li>
              Click on <strong>Create Event</strong> to start.
            </li>
            <li>
              Fill in all the required <strong>event details</strong> and click{" "}
              <strong>Create</strong>.
            </li>
          </ul>
          <br />
          <p>
            Already have some events? Just click the{" "}
            <strong>'+ New Event'</strong> button at the top of your Events
            Dashboard to add another one.
          </p>
          <img src={create_event} loading="lazy" />
        </>
      ),
      personMsg: <p>How to create an event?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How to create guest information form?",
      key: "event_creation2",
      botMsg: (
        <>
          <p>
            While setting up your event, you’ll find a{" "}
            <strong>Guest Information Form </strong>
            section. Here, you can <strong>drag and drop</strong> different
            fields (like dropdowns, radio buttons, etc.) to add custom
            questions.
          </p>
          <p>
            Your guests will fill out this form when they register for the
            event.
          </p>
        </>
      ),
      personMsg: <p>How to create guest information form?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How to Edit/Modify Event?",
      key: "event_creation3",
      botMsg: (
        <>
          <ul>
            <li>
              Click on the <strong>event card</strong> you want to edit.
            </li>
            <li>
              Tap the <strong>three dots</strong>{" "}
              <img
                src={kebabMenuCircle}
                style={{
                  display: "inline-block",
                  width: "18px",
                  margin: "0",
                  borderRadius: "50%",
                }}
              />
              in the top-right corner.
            </li>
            <li>
              Select <strong>Edit Event</strong>.
            </li>
            <li>
              Update any details as needed, then click <strong>Save</strong> to
              apply the changes.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to Edit/Modify Event?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How to change Event Banner?",
      key: "event_creation4",
      botMsg: (
        <>
          <ul>
            <li>Click on the event card you created.</li>
            <li>
              On the banner screen, tap the <strong>Upload</strong> option.
            </li>
            <li>
              Choose a new image, and it will instantly update as your event
              banner.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to change Event Banner?</p>,
      hasSuggestion: false,
    },
  ],
  invitation_registration: [
    {
      lable: "As a host , how can I invite guest to the event?",
      key: "invitation_registration1",
      botMsg: (
        <>
          <p>
            You have <strong>4 easy ways</strong> to invite guests:
          </p>
          <ol>
            <li>
              <strong>Invite Individually:</strong>
              <ul>
                <li>
                  Go to the <strong>Guests</strong> tab &gt; click{" "}
                  <strong>Invite Guest </strong> &gt; fill in the guest’s
                  details and send the invite.
                </li>
              </ul>
            </li>
            <li>
              <strong>Bulk Invite (Multiple Guests):</strong>
              <ul>
                <li>
                  Go to the <strong>Guests</strong> tab &gt; click{" "}
                  <strong>Invite Guest</strong> &gt; choose Bulk Upload.
                </li>
                <li>
                  Download the <strong>sample Excel file</strong>, fill in all
                  guest details, save it, then upload the file to invite
                  everyone at once.
                </li>
              </ul>
            </li>
            <li>
              <strong>Share Event QR Code:</strong>
              <ul>
                <li>
                  Simply share your <strong>Event QR Code</strong> with guests.
                </li>
                <li>
                  They can scan it using the{" "}
                  <strong>JioAICloud application</strong> to register.
                </li>
              </ul>
            </li>
            <li>
              <strong>Share Event Code:</strong>
              <ul>
                <li>
                  Share the <strong>Event Code</strong> with your guests.
                </li>
                <li>
                  They can enter the code in the{" "}
                  <strong>JioAICloud application</strong> to register.
                </li>
              </ul>
            </li>
          </ol>
          <img src={invite_guest} loading="lazy" />
        </>
      ),
      personMsg: <p>As a host , how can I invite guest to the event?</p>,
      hasSuggestion: false,
    },
    {
      lable:
        "As a guest I have Scanned QR/Event code to register for the event. But why am I not able to view the event?",
      key: "invitation_registration2",
      botMsg: (
        <>
          <p>
            You’ve successfully registered, but the{" "}
            <strong>event may be private</strong>. Once the{" "}
            <strong>host approves</strong> your registration, the event will
            appear in your list automatically.
          </p>
        </>
      ),
      personMsg: (
        <p>
          As a guest I have Scanned QR/Event code to register for the event. But
          why am I not able to view the event?
        </p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "How do I share the Event QR Code to my guests?",
      key: "invitation_registration3",
      botMsg: (
        <>
          <ul>
            <li>After creating your event, click on the event card.</li>
            <li>
              Select the <strong>QR Code icon</strong> from the Events tab.
            </li>
            <li>
              Download the QR and share it with your guests via email, WhatsApp,
              or any preferred channel.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How do I share the Event QR Code to my guests?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How to scan event QR Code and be part (guest) of the event?",
      key: "invitation_registration4",
      botMsg: (
        <>
          <p>You can scan the Event QR in two ways:</p>
          <ul>
            <li>
              <strong>Using your phone’s camera application</strong>, or
            </li>
            <li>
              <strong>
                From the JioAICloud application &gt; PhotoShare tab &gt; camera
                icon (top-right corner)
              </strong>
              .
            </li>
          </ul>
          <p>
            After scanning, you’ll be redirected to the{" "}
            <strong>event registration page</strong> — just fill in your details
            to join.
          </p>
        </>
      ),
      personMsg: (
        <p>How to scan event QR Code and be part (guest) of the event?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "How to share Event Code to my guests?",
      key: "invitation_registration5",
      botMsg: (
        <>
          <ul>
            <li>
              Go to the <strong>Events</strong> tab on your web portal.
            </li>
            <li>
              Copy the <strong>Event Code</strong> and share it directly with
              your guests (via message or email).
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to share Event Code to my guests?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How can I use the Event Code shared by the organizer to join?",
      key: "invitation_registration6",
      botMsg: (
        <>
          <ul>
            <li>
              {" "}
              Open the{" "}
              <strong>
                JioAICloud app &gt; PhotoShare tab &gt; camera icon (top-right
                corner)
              </strong>
              .
            </li>
            <li>
              Enter the <strong>Event Code</strong> shared by your organizer and
              register for the event.
            </li>
          </ul>
        </>
      ),
      personMsg: (
        <p>How can I use the Event Code shared by the organizer to join?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "How to Block a Guest?",
      key: "invitation_registration7",
      botMsg: (
        <>
          <ul>
            <li>
              Open your <strong>event</strong> &gt; go to the{" "}
              <strong>Guests</strong> tab &gt; select{" "}
              <strong>All Guests</strong>.
            </li>
            <li>
              Tap on the guest’s name &gt; click the <strong>pencil</strong>{" "}
              icon &gt; choose <strong>Block Guest</strong>.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to Block a Guest?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How to Restore a Guest?",
      key: "invitation_registration8",
      botMsg: (
        <>
          <ul>
            <li>
              Open your <strong>event</strong> &gt; go to the{" "}
              <strong>Guests</strong> tab &gt; select{" "}
              <strong>Blocked Guests</strong>.
            </li>
            <li>
              Find the guest you want to restore and <strong>unblock</strong>{" "}
              them.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to Restore a Guest?</p>,
      hasSuggestion: false,
    },
  ],
  upload: [
    {
      lable: "How to upload photos in my event?",
      key: "upload1",
      botMsg: (
        <>
          <ul>
            <li>
              For uploading photos to the event, as an event organizer, you need
              to login on your web portal -{" "}
              <a
                style={{ color: "#0277ad" }}
                href="https://www.jioaicloud.com/"
                target="_blank"
              >
                www.jioaicloud.com
              </a>
              , navigate to PhotoShare tab, create folder and upload photos from
              the Albums tab.
            </li>
            <li>
              For uploading photos to the event, as a guest, you just need to
              navigate to PhotoShare tab on your JioAICloud application and
              click on the event and its album in which you wish to upload
              folders. Click on Upload icon and start uploading the photos.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to upload photos in my event?</p>,
      hasSuggestion: false,
    },
  ],
  share_photos: [
    {
      lable: "How to share the photos with my guests?",
      key: "share_photos1",
      botMsg: (
        <>
          <ul>
            <li>
              Go to the <strong>PhotoShare</strong> tab on your dashboard.
            </li>
            <li>
              Open your <strong>Event</strong>, then click on the{" "}
              <strong>Share Photos</strong> tab.
            </li>
            <li>Select the guest and give access.</li>
            <li>
              Choose the <strong>type of access</strong> you want to give your
              guests — you can control what they can view, download, or upload.
            </li>
          </ul>
          <p>Here’s what each access type means</p>
          <ul>
            <li>
              <strong>Full Access: </strong>
              Guests can view <strong>all event photos</strong> without
              restrictions.
            </li>
            <li>
              <strong>Face Access: </strong> Guests can view{" "}
              <strong>only their own photos</strong> detected from the event.
            </li>
            <li>
              <strong>Download Access: </strong> Guests can{" "}
              <strong>download photos</strong> from the event.
            </li>
            <li>
              <strong>Upload Access: </strong> Guests can{" "}
              <strong>upload photos</strong> to the event.
            </li>
          </ul>
          <img src={share_access} loading="lazy" />
        </>
      ),
      personMsg: <p>How to share the photos with my guests?</p>,
      hasSuggestion: false,
    },
  ],
  face_myphotos: [
    {
      lable:
        "The Faces tab is empty even after uploading images. What should I do?",
      key: "face_myphotos1",
      botMsg: (
        <>
          <p>
            Face processing may take time, especially if a large number of
            photos are being processed. Please wait a few minutes and check the
            Faces Status for progress.
          </p>
          <p>If faces are still not visible after some time:</p>
          <ul>
            <li>Try logging out and logging back in.</li>
            <li>Refresh your browser page.</li>
            <li>
              If the issue continues, contact our support team at{" "}
              <a href="mailto:care.photoshare@jio.com">
                care.photoshare@jio.com
              </a>{" "}
              with your event name and registered details for assistance.
            </li>
          </ul>
        </>
      ),
      personMsg: (
        <p>
          The Faces tab is empty even after uploading images. What should I do?
        </p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "My photos under “My Photos” are not visible to guests. Why?",
      key: "face_myphotos2",
      botMsg: (
        <>
          <p>
            Face recognition may not work correctly in some cases, especially
            now that Liveness Detection is implemented. Please ensure your
            profile photo passes the liveness check and meets the below
            conditions:
          </p>
          <ul>
            <li>Your face must be clearly visible and front-facing.</li>
            <li>
              The photo should be taken in good lighting and without blur or
              filters.
            </li>
            <li>Avoid side profiles, group photos, or busy backgrounds.</li>
            <li>
              Make sure your liveness capture (selfie verification) was
              successful during upload.
            </li>
          </ul>
          <p>
            Tip: If your “My Photos” are still not showing, re-upload a clear,
            front-facing selfie through the PhotoShare tab. This ensures
            accurate face matching for your event photos.
          </p>
        </>
      ),
      personMsg: (
        <p>My photos under “My Photos” are not visible to guests. Why?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "What should I do if my system shuts down during photo upload?",
      key: "face_myphotos3",
      botMsg: (
        <>
          <p>If your device restarts while uploading:</p>
          <ul>
            <li>
              Reboot your system and reopen the JioAICloud → PhotoShare
              dashboard.
            </li>
            <li>
              Re-upload the same photos (the system will skip already uploaded
              ones).
            </li>
            <li>Avoid running multiple heavy apps during upload.</li>
            <li>
              If this happens often, check your system memory or reach out to IT
              support.
            </li>
          </ul>
        </>
      ),
      personMsg: (
        <p>What should I do if my system shuts down during photo upload?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "Faces are not being tagged. What could be the issue?",
      key: "face_myphotos4",
      botMsg: (
        <>
          <p>This can happen due to:</p>
          <ul>
            <li>A large upload volume, delaying face clustering.</li>
            <li>Low system memory or browser overload.</li>
          </ul>
          <p>
            Wait a few minutes for clustering to complete. Try uploading photos
            in smaller batches and keep the browser tab active. If clustering
            still doesn’t start, email{" "}
            <a href="mailto:care.photoshare@jio.com">care.photoshare@jio.com</a>{" "}
            for help.
          </p>
        </>
      ),
      personMsg: <p>Faces are not being tagged. What could be the issue?</p>,
      hasSuggestion: false,
    },
    {
      lable: "As a host, when can I share event photos with guests?",
      key: "face_myphotos5",
      botMsg: (
        <>
          <p>You can share photos only after face clustering is complete.</p>
          <p>To check the status:</p>
          <ul>
            <li>Go to your Event &gt; Faces tab &gt; Face Status.</li>
            <li>
              If the Pending count = 0, clustering is complete, you can share
              photos with guests.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>As a host, when can I share event photos with guests?</p>,
      hasSuggestion: false,
    },
    {
      lable: "A guest’s photos are missing. What should I do as a host?",
      key: "face_myphotos6",
      botMsg: (
        <>
          <p>Try the following:</p>
          <ol>
            <li>
              Check Face Clustering Status
              <ul style={{ listStyleType: "circle", marginLeft: "8px" }}>
                <li>
                  Go to the Faces tab and verify if clustering is still in
                  progress. Large uploads may take a few hours.
                </li>
              </ul>
            </li>
            <li>
              Verify Guest’s Profile Photo
              <ul style={{ listStyleType: "circle", marginLeft: "8px" }}>
                <li>
                  Go to the Guests tab and check if the guest has a clear,
                  front-facing profile photo uploaded.
                </li>
                <li>If missing or unclear, ask the guest to:</li>
                <ul style={{ marginLeft: "12px" }}>
                  <li>Open the JioAICloud app (Android/iOS)</li>
                  <li>
                    Go to Files &gt; PhotoShare (or from the home page
                    PhotoShare section)
                  </li>
                  <li>Tap the profile picture icon</li>
                  <li>
                    Upload a clear, front-facing photo with no background
                    distractions
                  </li>
                </ul>
              </ul>
            </li>
            <p>
              Once updated, the system will automatically reprocess, and the
              guest’s photos will appear under their My Photos folder.
            </p>
            <p>
              Note: If photos still don’t appear, check if the guest’s face is
              clearly visible in the uploaded photos. Blurry or side-facing
              photos may not be detected.
            </p>
          </ol>
        </>
      ),
      personMsg: (
        <p>A guest’s photos are missing. What should I do as a host?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable:
        "I updated my profile photo in JioAICloud application, but “My Photos” are still empty. What should I do?",
      key: "face_myphotos7",
      botMsg: (
        <>
          <p>
            <strong>
              Updating your photo in the general JioAICloud profile doesn’t
              update your PhotoShare (Events) profile.
            </strong>
          </p>
          <p> Please update your profile photo within PhotoShare:</p>
          <p>Steps:</p>
          <ul>
            <li>Open the JioAICloud app (Android/iOS)</li>
            <li>
              Go to Files &gt; PhotoShare or the PhotoShare section on the home
              page
            </li>
            <li>
              Upload a clear, front-facing photo with no background distractions
            </li>
          </ul>
          <p>
            Once updated, face recognition will start and your photos will
            appear under “My Photos”.
          </p>
        </>
      ),
      personMsg: (
        <p>
          I updated my profile photo in JioAICloud application, but “My Photos”
          are still empty. What should I do?
        </p>
      ),
      hasSuggestion: false,
    },
    {
      lable:
        "As a host, I can’t find a guest’s images in an event. How can I locate them?",
      key: "face_myphotos8",
      botMsg: (
        <>
          <ul>
            <li>Go to the Faces tab.</li>
            <li>
              You can search by the Guest’s name Or click the Search by Image
              icon.
            </li>
            <li>
              Upload a clear single photo of the guest (front-facing, plain
              background). The system will show all matches found for that
              person.
            </li>
          </ul>
        </>
      ),
      personMsg: (
        <p>
          As a host, I can’t find a guest’s images in an event. How can I locate
          them?
        </p>
      ),
      hasSuggestion: false,
    },
    {
      lable:
        "My “My Photos” folder was showing images yesterday, but now it’s empty. What should I do?",
      key: "face_myphotos9",
      botMsg: (
        <>
          <ul>
            <li>First, check your internet connection.</li>
            <li>
              Sometimes, temporary backend updates or deployments may cause a
              delay in photo listing. Wait for a while and then refresh — your
              photos should reappear once processing stabilizes.
            </li>
          </ul>
        </>
      ),
      personMsg: (
        <p>
          My “My Photos” folder was showing images yesterday, but now it’s
          empty. What should I do?
        </p>
      ),
      hasSuggestion: false,
    },
  ],
  public_private_folder: [
    {
      lable: "What is the reason for creating folders - public and private?",
      key: "public_private_folder1",
      botMsg: (
        <>
          <p>
            Public folders are specially designed to keep generic pictures which
            should be seen by everyone without any restrictions. Example, you
            are hosting an event but similar event you hosted last year, you can
            give glimpse of last year's photos, or you can upload invitations of
            current year event etc. Whereas private folders are accessible to
            guests only based on their access type. If a guest has full access,
            he can see all photos and if a guest has face access, he can see
            only his photos. Thus, allowing the host to have maximum control.
          </p>
        </>
      ),
      personMsg: (
        <p>What is the reason for creating folders - public and private?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable:
        "I cannot upload to the Event Photos folder as a guest. What can be the reason?",
      key: "public_private_folder2",
      botMsg: (
        <>
          <p>
            You, as a guest, can only have option to upload the photos in
            private folders. The ‘Event Photos’ mentioned here can be public and
            hence, uploading of guest photos is restricted in the same.
          </p>
        </>
      ),
      personMsg: (
        <p>
          I cannot upload to the Event Photos folder as a guest. What can be the
          reason?
        </p>
      ),
      hasSuggestion: false,
    },
  ],
  upload_download: [
    {
      lable: " Why can’t I upload more than 25 images at a time?",
      key: "upload_download1",
      botMsg: (
        <>
          <p>
            This is a <strong>built-in application feature</strong>. Guests can
            upload a maximum of <strong>25 images per batch</strong> to ensure
            smooth uploads and reduce network load. Typically, guests don’t need
            to upload large volumes — this limit helps maintain optimal app
            performance for everyone.
          </p>
        </>
      ),
      personMsg: <p> Why can’t I upload more than 25 images at a time?</p>,
      hasSuggestion: false,
    },
    {
      lable: " If I upload photos to an event, will it use my cloud storage?",
      key: "upload_download2",
      botMsg: (
        <>
          <p>
            No. All photos uploaded to an event are stored under the{" "}
            <strong> Host’s event storage</strong>, not your personal cloud
            space.
          </p>
        </>
      ),
      personMsg: (
        <p>If I upload photos to an event, will it use my cloud storage?</p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "If I download event photos, will it use my cloud storage?",
      key: "upload_download3",
      botMsg: (
        <>
          <p>
            No. Downloaded photos are saved locally on your device or system, so
            they don’t count toward your cloud storage.
          </p>
        </>
      ),
      personMsg: (
        <p>If I download event photos, will it use my cloud storage?</p>
      ),
      hasSuggestion: false,
    },
  ],
  event_changes: [
    {
      lable: "How will I know if an event is rescheduled as a guest?",
      key: "event_changes1",
      botMsg: (
        <>
          <p>
            As a guest, you’ll receive an instant notification whenever the host
            updates or reschedules the event. You can check the updated date and
            time directly in your event details.
          </p>
        </>
      ),
      personMsg: <p>How will I know if an event is rescheduled as a guest?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How will I know if an event is cancelled as a guest?",
      key: "event_changes2",
      botMsg: (
        <>
          <p>
            If an event is cancelled, you’ll also get a notification right away.
            The event will be marked as Cancelled in your event list, and you
            won’t be able to access it further.
          </p>
        </>
      ),
      personMsg: <p>How will I know if an event is cancelled as a guest?</p>,
      hasSuggestion: false,
    },
    {
      lable: "How can I cancel an event? (For Hosts)",
      key: "event_changes3",
      botMsg: (
        <>
          <ul>
            <li>Open the event you created.</li>
            <li>
              Tap the three dots{" "}
              <img
                src={kebabMenuCircle}
                style={{
                  display: "inline-block",
                  width: "18px",
                  margin: "0",
                  borderRadius: "50%",
                }}
              />{" "}
              in the top-right corner.
            </li>
            <li>Choose Cancel Event.</li>
            <li>
              Select the reason for cancellation and confirm. Your guests will
              automatically be notified once the event is cancelled.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How can I cancel an event? (For Hosts)</p>,
      hasSuggestion: false,
    },
  ],
  folder_creation_upload: [
    {
      lable: "How to create a folder/album?",
      key: "folder_creation_upload1",
      botMsg: (
        <>
          <ul>
            <li>Go to your Event.</li>
            <li>Click on Albums tab</li>
            <li>Click on New Folder to create a folder.</li>
            <li>
              You can create <strong>multiple folders</strong> as needed to
              organize your photos better.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How to create a folder/album?</p>,
      hasSuggestion: false,
    },
    {
      lable: "Why are folders categorized as Public and Private?",
      key: "folder_creation_upload2",
      botMsg: (
        <>
          <p>
            <strong>Public Folders</strong>
          </p>
          <ul>
            <li>Used for photos that everyone can view — no restrictions.</li>
            <li>
              Ideal for things like last year’s event highlights, invitations,
              or general event photos.
            </li>
          </ul>
          <p>
            <strong>Private Folders</strong>
          </p>
          <ul>
            <li>
              Accessible only to guests based on their{" "}
              <strong>access type</strong>:
              <ul style={{ listStyleType: "circle", marginLeft: "8px" }}>
                <li>
                  {" "}
                  <strong>Full Access</strong>: Can view all photos.
                </li>
                <li>
                  <strong>Face Access</strong>: Can view only photos that match
                  their face.
                </li>
              </ul>
            </li>
            <li>This gives the host complete control over who sees what.</li>
          </ul>
        </>
      ),
      personMsg: <p>Why are folders categorized as Public and Private?</p>,
      hasSuggestion: false,
    },
    {
      lable:
        "I can’t upload photos to the “Event Photos” folder as a guest. Why?",
      key: "folder_creation_upload3",
      botMsg: (
        <>
          <p>
            The <strong>Event Photos</strong> folder might be a{" "}
            <strong>public folder</strong>, and guest uploads are not allowed
            there. Guests can upload photos{" "}
            <strong>only in Private folders</strong> assigned to them.
          </p>
        </>
      ),
      personMsg: (
        <p>
          I can’t upload photos to the “Event Photos” folder as a guest. Why?
        </p>
      ),
      hasSuggestion: false,
    },
    {
      lable: "How can I upload photos to my event?",
      key: "folder_creation_upload4",
      botMsg: (
        <>
          <p>
            <strong>As an Organizer:</strong>
          </p>
          <ul>
            <li>
              Go to the <strong>PhotoShare</strong> tab &gt; open your event
              &gt; <strong>Albums</strong> tab.
            </li>
            <li>Create a folder and upload photos directly from there.</li>
          </ul>
          <p>
            <strong>As a Guest:</strong>
          </p>
          <ul>
            <li>
              Open the <strong>JioAICloud application</strong> &gt; go to{" "}
              <strong>PhotoShare option from Files tab</strong> &gt; open the
              event and select the album you want.
            </li>
            <li>
              Tap the <strong>Upload</strong> icon and start uploading your
              photos instantly.
            </li>
          </ul>
        </>
      ),
      personMsg: <p>How can I upload photos to my event?</p>,
      hasSuggestion: false,
    },
  ],
};
